import { APIClient } from '@/_helpers/APIClient'

export default {
  getItem (payload) {
    let path = './api/detail-get-item.json?id=' + payload.id
    return APIClient().get(path)
  }
}
